<!--
 * @Author: your name
 * @Date: 2022-06-13 14
-->
<template>
  <div>
    <!-- <heads></heads> -->
    <div class="dv">
      <baidu-map
        id="addmap"
        class="map"
        :center="markerPoint1"
        :zoom="10"
        :scroll-wheel-zoom="true"
      >
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <!-- 遍历多个点坐标 -->
        <template v-for="(item, index) in addDetails">
          <bm-marker
            :key="index"
            :position="item.position"
            @click="look(item)"
          >
          </bm-marker>
        </template>
      </baidu-map>
    </div>
    <div class="addimport">
     <van-dropdown-menu style="width:100%;">
        <van-dropdown-item ref="dropdown1" v-model="province" :options="option1" @change="provinceConfirm"/>
        <van-dropdown-item ref="dropdown2" v-model="city" :options="option2" @change="cityConfirm"/>
      </van-dropdown-menu>
    </div>
    <!-- 隐藏显示按钮 -->
    <div class="showBtn">
      <img @click="clickShow()" v-if="isShow" class="yincangImg" src="../../assets/icon/home/yincang.png" alt="">
      <img @click="clickShow()" v-else class="yincangImg2" src="../../assets/icon/home/xianshi.png" alt="">
    </div>
    <div class="add-details" v-if="isShow">
        <div class="add-list" v-for="(item,index) in storeList" :key="index">
          <div class="add-top">
              <img src="../../assets/icon/home/logo.png" alt="">
              <div class="top-text">{{item.storeName}}</div>
          </div>
          <div class="address">{{item.addr}}</div>
          <div class="time">营业时间：{{item.openingHours}}</div>
          <div class="phone">热线服务：{{item.linkTel}}</div>
          <div class="btn" @click="topath(item)">新车在店 预约试驾</div>
        </div>
        <div>
          <van-loading v-if="loadingList == true" class="longding" color="#FBCC0A"/>
          <van-empty v-if="loadingList==false && addDetails.length<=0" description="暂无门店" />
        </div>
    </div>
  </div>
</template>
<script>
// import Heads from "@/components/Heads.vue";
import { getAreaListApi, getStoresApi } from "@/api/api";
import { DropdownMenu, DropdownItem, Empty, Loading  } from "vant";
export default {
  components:{
    // Heads,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Empty.name]:Empty,
    [Loading.name]:Loading
  },
  data(){
    return{
      addressicon:require('../../assets/icon/home/address.png'),
      position:{},
      show: false,
      from:{},
      markerPoint1: { lng: 106.534984, lat: 29.577722 },
      province:'1',
      city:'36',
      cityName:'',
      option1: [],
      option2: [],
      addDetails:[],
      storeList:[],
      isShow:false,
      loadingList:false
    }
  },
  created(){
    this.getAreaListApi()
  },
  methods:{
    getAreaListApi(){
      this.loadingList = true
      const datas = {
        m:'Mobile',
        c:'Area',
        a:'get_tree_list'
      }
      getAreaListApi(datas).then(({data})=>{
        data.data.forEach(item => {
          item.text = item.area_name
          item.value = item.area_id
          item.children.forEach(item1=>{
            item1.text = item1.area_name
            item1.value = item1.area_id
          })
        });
        this.option1 = data.data
        this.option2 = data.data[0].children
        this.cityConfirm()
      })
    },
    // 选择省后触发，切换市选择列表
    provinceConfirm(value){
      if (this.addDetails.length!=0) {
        this.addDetails = []
      }
      this.loadingList = true
      const datas = {
        m:'Mobile',
        c:'Area',
        a:'get_tree_list'
      }
      getAreaListApi(datas).then(({data})=>{
        data.data.forEach(item => {
          item.text = item.area_name
          item.value = item.area_id
          item.children.forEach(item1=>{
            item1.text = item1.area_name
            item1.value = item1.area_id
          })
          if (value == item.area_id) {
            this.option2 = item.children
            this.city = item.children[0].area_id
            this.cityName = item.children[0].area_name
          }
        });
        this.cityConfirm()
      })
    },
    // 选择市后触发
    cityConfirm(val){
      if (this.cityName == '') {
        this.cityName = '北京市'
      }else{
        this.option2.forEach((item,idx) => {
          if (item.area_id == val) {
            this.cityName = item.area_name
          }
        });
      }
      const params = {
        condition:'',
        locations:'',
        isFindGrade: 1,
        city:this.cityName
      }
      getStoresApi(params).then(({data})=>{

        if (data.result&&data.result.length>0) {
          this.isShow = true
          data.result.forEach(item => {
            item.position = { lng: item.longitude, lat: item.latitude }
          });
          this.addDetails = data.result
          this.storeList = data.result
          this.markerPoint1 = { lng: data.result[0].longitude, lat: data.result[0].latitude }
          this.loadingList = false
        }
        if (data.result.length == 0) {
          this.storeList = []
          this.loadingList = false
          this.isShow = false
        }
      })
    },
    // 点击显示/隐藏门店列表
    clickShow(){
      this.isShow = !this.isShow
    },
    // 点击坐标点
    look(item){
      this.storeList = []
      this.storeList.push(item)
      this.isShow = true
    },
    // 跳转到 - 预约试驾
    topath(item){
      this.$router.push({
        path:'/subscribe',
        query:{
          chain_id:item.storeId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
